import {
  FiscalRepSubscriptionRowFragment,
  NifOrderRowFragment,
} from '@src/generated/graphql';

export type OrderItemBadgeType =
  | 'DRAFT'
  | 'PENDING'
  | 'ACTION_REQUIRED'
  | 'COMPLETE'
  | 'CANCELLED'
  | 'INACTIVE'
  | 'CANCELLATION_PENDING'
  | 'UNPAID';

export type OrderItemStatusIconType = 'ACTION' | 'INFO' | 'SUCCESS';

interface OrderStateConfig {
  priority: number;
  isInactive: boolean;
  badge?: OrderItemBadgeType;
  icon?: OrderItemStatusIconType;
}

export const ORDER_STATE_CONFIG = {
  PENDING_CUSTOMER_ACTION: {
    priority: 1,
    badge: 'ACTION_REQUIRED',
    isInactive: false,
  },
  DRAFT: {
    priority: 2,
    badge: 'DRAFT',
    isInactive: false,
  },
  PENDING_BORDR_ACTION: {
    priority: 3,
    badge: 'PENDING',
    isInactive: false,
  },
  COMPLETED: {
    priority: 4,
    badge: 'COMPLETE',
    isInactive: true,
  },
  CANCELLED: {
    priority: 5,
    badge: 'CANCELLED',
    isInactive: true,
  },
} satisfies Record<string, OrderStateConfig>;

export type OrderState = keyof typeof ORDER_STATE_CONFIG;

export interface OrderStatusInfo {
  state: OrderState;
  isInactive?: boolean;
  badge?: OrderItemBadgeType | null;
  message?: string;
}

export type NifOrderStatusInfo = OrderStatusInfo;

export interface FiscalRepSubscriptionStatusInfo extends OrderStatusInfo {
  signedContractFileId?: string | null;
  canCancel?: boolean;
  canUpdatePaymentMethod?: boolean;
  signAgreementUrl?: string;
  needsReupload?: boolean;
}

export type OrderRowFragment =
  | NifOrderRowFragment
  | FiscalRepSubscriptionRowFragment;

export type OrderRowWithInfo =
  | { row: NifOrderRowFragment; info: NifOrderStatusInfo }
  | {
      row: FiscalRepSubscriptionRowFragment;
      info: FiscalRepSubscriptionStatusInfo;
    };
